import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query';

const STORAGE_KEY = "appToken";

export interface AuthContextType {
  user: any | null,
  login: (userData: any) => void,
  logout: () => void,
}

export const useAuth = () => {
  const queryClient = useQueryClient();
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem(STORAGE_KEY)
    return token;
  })

  const login = (userData: any) => {
    setUser(userData)
    localStorage.setItem(STORAGE_KEY, userData.token)
  }

  const logout = () => {
    setUser(null);
    localStorage.removeItem(STORAGE_KEY);
    queryClient.removeQueries({ queryKey: ['user-config'] });
  }

  return { user, login, logout }
}
